import type { ReactNode } from "react";
import { useEffect } from "react";
import useDeviceSize from "hooks/useDeviceSize";
import { useExtendedRouter } from "hooks";
import { Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton } from "@chakra-ui/react";
import { useMobileMenuStore } from "stores/MobileMenuStore";

const SideMenu = ({ isOpen, close, content }: { isOpen: boolean; close: () => void; content: ReactNode }) => (
  <Drawer isOpen={isOpen} onClose={close} size={{ base: "xl", md: "md" }}>
    <DrawerOverlay bg="rgba(69, 84, 115, 0.7)" />
    <DrawerContent h="full" boxShadow="none">
      <DrawerCloseButton
        size="lg"
        color="primary.900"
        _hover={{ color: "primary.500", bg: "white" }}
        _active={{ color: "primary.700", bg: "white" }}
        rounded="full"
        right={2}
      />
      {content}
    </DrawerContent>
  </Drawer>
);

export const MobileSideMenu = () => {
  const { isOpen, close, content } = useMobileMenuStore();
  const { isDesktop } = useDeviceSize();
  const router = useExtendedRouter();

  useEffect(() => {
    if (isDesktop) close();
  }, [isDesktop, close]);

  useEffect(() => {
    router.events.on("beforeHistoryChange", close);

    return () => {
      router.events.off("beforeHistoryChange", close);
    };
  }, [router, close]);

  return <SideMenu isOpen={isOpen} close={close} content={content} />;
};
